import { TriggerItem } from "@radix-ui/react-dropdown-menu";

import { item } from "../../css/menu";
import { styled } from "../../theme";

export const DropdownSubmenuTrigger = styled(TriggerItem, item);
